<app-fire-and-flower-shelf-talker-content
  [data]="data"
  [parentHeight]="parentHeight"
  [parentWidth]="parentWidth"
  [preview]="preview">
</app-fire-and-flower-shelf-talker-content>
